import Table from "components/table";
import { withTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import proofMissingWarningIcon from "assets/images/proof-missing-warning.svg";
import ThreeDots from "assets/images/threedots.svg";
import sortIcon from "assets/images/mir-ico-sort.svg";
import Text from "components/Text";
import profileStyles from "../Auth/components/Profile/profile.module.scss";
import { CREDENTIAL_TYPE } from "features/credentials/credentialTypes";
import moment from "moment";
import { getDocumentStatus, hasProofDocument } from "./CredentialTypeStatus";
import constants, { CREDENTIAL_STATUS } from "../../constants";
import { encodeId } from "utils";
import styles from "./CredentialsAndLicensingGlobalListing.module.scss";
import "./CredentialsAndLicensingGlobalListing.scss";
import { useCallback, useRef } from "react";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import {
  getCredentialDisplayName,
  isOtherOwnerCredential,
} from "features/credentials/utils/normalizeCredentialMaster";
import OtherOwnerAwareDropdownItem from "features/credentials/OtherOwnerActionInfo";
import { useComplianceTableRowClick } from "accountOwner/pages/OfficePolicyManagement/hooks/useComplianceTableRowClick";
export const sortingVariables = {
  // UserName = 1,
  UserName: 1,
  CredentialName: 2,
  CredentialType: 3,
  IssuingAuthority: 4,
  CredentialId: 5,
  IssueDate: 6,
  ExpiryDate: 7,
  Documentation: 8,
};
const PAGE_SIZE = constants.pageSize;
const CredentialGlobalTable = ({
  t,
  data = [],
  sortBy,
  isDescending,
  officeTable = false,
  onEdit,
  handleSetSortByAndIsDescending,
  onDelete,
  pageNumber = 1,
  setPageNumber,
  totalItems = 0,
}) => {
  const history = useHistory();
  const { selectedOwnerIdString } = useAccountOwnerCommon();
  const handleView = useCallback(
    (row) => {
      const route =
        constants.routes.credentialsAndLicensing.credentialsAndLicensingGlobalDetail.replace(
          ":id",
          encodeId(row.id),
        );
      history.push({
        pathname: route,
        search: selectedOwnerIdString ? `?${selectedOwnerIdString}` : "",
        state: { isOtherOwner: isOtherOwnerCredential(row) },
      });
    },
    [history, selectedOwnerIdString],
  );
  const { preventRowNavigation, runDropdownAction, rowEvents } =
    useComplianceTableRowClick(handleView);

  const sortAndAscDescSetter = (assignSort) => {
    let newIsDescending = true;
    if (sortBy === assignSort) {
      newIsDescending = !isDescending;
    }
    handleSetSortByAndIsDescending(assignSort, newIsDescending);
    // Note: setSortBy and setIsDescending from the hook already handle localStorage saving
  };
  const openRef = useRef(null);
  const columns = [
    {
      attrs: {
        datatitle: officeTable
          ? t("accountOwner.officeName")
          : t("accountOwner.staffMember"),
      },
      dataField: officeTable ? "Office Name" : "Staff Member",
      headerFormatter: () => {
        return (
          <div className="d-flex align-items-center gap-xs mb-1">
            <button
              className={
                "reset-btn flex-shrink-null " + styles["th-btn-wrapper"]
              }
              onClick={() => {
                sortAndAscDescSetter(sortingVariables.UserName);
              }}
            >
              <span>
                {officeTable
                  ? t("accountOwner.officeName")
                  : t("accountOwner.staffMember")}
              </span>

              <img
                src={sortIcon}
                alt="sortIcon"
                style={{
                  transform:
                    isDescending && sortBy === sortingVariables.UserName
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                }}
              />
            </button>
          </div>
        );
      },
      formatter: (cellContent, row) => {
        const { userName, officeName } = row;
        return (
          <span className="credential-table-cell">
            {officeTable ? officeName : userName}
          </span>
        );
      },
    },
    {
      attrs: {
        datatitle: t("accountOwner.credentialName"),
      },
      dataField: "Credential Name",
      headerFormatter: () => {
        return (
          <div className="d-flex align-items-center gap-xs mb-1">
            <button
              className={
                "reset-btn flex-shrink-null " + styles["th-btn-wrapper"]
              }
              onClick={() => {
                sortAndAscDescSetter(sortingVariables.CredentialName);
              }}
            >
              <span>{t("accountOwner.credentialName")}</span>
              <img
                src={sortIcon}
                alt="sortIcon"
                style={{
                  transform:
                    isDescending && sortBy === sortingVariables.CredentialName
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                }}
              />
            </button>
          </div>
        );
      },
      formatter: (cellContent, row) => (
        <span className="credential-table-cell">
          {getCredentialDisplayName(row)}
        </span>
      ),
      sort: true,
    },
    {
      attrs: {
        datatitle: t("accountOwner.type"),
      },
      dataField: "Type",
      headerFormatter: () => {
        return (
          <div className="d-flex align-items-center gap-xs mb-1">
            <button
              className={
                "reset-btn flex-shrink-null " + styles["th-btn-wrapper"]
              }
              onClick={() => {
                sortAndAscDescSetter(sortingVariables.CredentialType);
              }}
            >
              <span>{t("accountOwner.type")}</span>
              <img
                src={sortIcon}
                alt="sortIcon"
                style={{
                  transform:
                    isDescending && sortBy === sortingVariables.CredentialType
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                }}
              />
            </button>
          </div>
        );
      },
      formatter: (cellContent, { credentialType }) => (
        <span className="credential-table-cell">
          {CREDENTIAL_TYPE.find((type) => type.id === credentialType)?.name}
        </span>
      ),
      sort: true,
    },
    {
      attrs: {
        datatitle: t("accountOwner.credentialId"),
      },
      dataField: "Credential ID",
      headerFormatter: () => {
        return (
          <div className="d-flex align-items-center gap-xs mb-1">
            <button
              className={
                "reset-btn flex-shrink-null " + styles["th-btn-wrapper"]
              }
              onClick={() => {
                sortAndAscDescSetter(sortingVariables.CredentialId);
              }}
            >
              <span>{t("accountOwner.credentialId")}</span>
              <img
                src={sortIcon}
                alt="sortIcon"
                style={{
                  transform:
                    isDescending && sortBy === sortingVariables.CredentialId
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                }}
              />
            </button>
          </div>
        );
      },
      formatter: (cellContent, { credentialId }) => (
        <span className="credential-table-cell">{credentialId || "--"}</span>
      ),
      sort: true,
    },
    {
      attrs: {
        datatitle: t("accountOwner.issueDate"),
      },
      dataField: "Issue Date",
      headerFormatter: () => {
        return (
          <div className="d-flex align-items-center gap-xs mb-1">
            <button
              className={
                "reset-btn flex-shrink-null " + styles["th-btn-wrapper"]
              }
              onClick={() => {
                sortAndAscDescSetter(sortingVariables.IssueDate);
              }}
            >
              <span>{t("accountOwner.issueDate")}</span>
              <img
                src={sortIcon}
                alt="sortIcon"
                style={{
                  transform:
                    isDescending && sortBy === sortingVariables.IssueDate
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                }}
              />
            </button>
          </div>
        );
      },
      formatter: (cellContent, { issueDate }) => (
        <span className="">
          {issueDate ? moment(issueDate).format("MMM DD, YYYY") : "--"}
        </span>
      ),
      sort: true,
    },
    {
      attrs: {
        datatitle: t("accountOwner.expiryDate"),
      },
      dataField: "Expiry Date",
      headerFormatter: () => {
        return (
          <div className="d-flex align-items-center gap-xs mb-1">
            <button
              className={
                "reset-btn flex-shrink-null " + styles["th-btn-wrapper"]
              }
              onClick={() => {
                sortAndAscDescSetter(sortingVariables.ExpiryDate);
              }}
            >
              <span>{t("accountOwner.expiryDate")}</span>
              <img
                src={sortIcon}
                alt="sortIcon"
                style={{
                  transform:
                    isDescending && sortBy === sortingVariables.ExpiryDate
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                }}
              />
            </button>
          </div>
        );
      },
      formatter: (cellContent, row) => {
        const { expiryDate, status } = row;
        const statusId = status != null ? +status : null;

        if (statusId === CREDENTIAL_STATUS.NO_EXPIRY) {
          return <span>{t("accountOwner.noExpiryStatus")}</span>;
        }
        if (statusId === CREDENTIAL_STATUS.EXPIRY_UNKNOWN || !expiryDate) {
          return (
            <span>
              {statusId === CREDENTIAL_STATUS.EXPIRY_UNKNOWN
                ? t("accountOwner.expiryUnknownStatus")
                : t("accountOwner.noExpiryDate")}
            </span>
          );
        }

        return (
          <span className={""}>
            {moment(expiryDate).format("MMM DD, YYYY")}
          </span>
        );
      },
    },
    {
      attrs: {
        datatitle: t("accountOwner.documentation"),
      },
      dataField: "Documentation",
      headerFormatter: () => {
        return (
          <div className="d-flex align-items-center gap-xs mb-1">
            <button
              className={
                "reset-btn flex-shrink-null " + styles["th-btn-wrapper"]
              }
              onClick={() => {
                sortAndAscDescSetter(sortingVariables.Documentation);
              }}
            >
              <span>{t("accountOwner.documentation")}</span>
              <img
                src={sortIcon}
                alt="sortIcon"
                style={{
                  transform:
                    isDescending && sortBy === sortingVariables.Documentation
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                }}
              />
            </button>
          </div>
        );
      },
      formatter: (cellContent, row) => {
        const isCompleted = hasProofDocument(row);
        if (isCompleted) {
          return (
            <span className="credential-table-cell">
              {t("accountOwner.completedStatus")}
            </span>
          );
        }
        return (
          <span className={styles["proof-missing"]}>
            <img
              src={proofMissingWarningIcon}
              alt=""
              className={styles["proof-missing-icon"]}
            />
            {t("accountOwner.proofMissingStatus")}
          </span>
        );
      },
    },
    {
      attrs: {
        datatitle: t("officePolicyManagement.status"),
      },
      dataField: "status",
      headerFormatter: () => {
        return (
          <div
            className="d-flex align-items-center gap-xs mb-1"
            style={{ height: "40px" }}
          >
            <span>{t("officePolicyManagement.status")}</span>
          </div>
        );
      },
      formatter: (cellContent, row) => {
        const status = getDocumentStatus(row, t);
        if (!status.showHide) {
          return null;
        }
        return (
          <span
            className={
              profileStyles["status"] +
              " " +
              profileStyles["status-" + status.customClass]
            }
          >
            {status.status}
          </span>
        );
      },
    },
    {
      attrs: {
        datatitle: t("accountOwner.action"),
      },
      dataField: "Action",
      headerFormatter: () => {
        return (
          <div
            className="d-flex align-items-center gap-xs mb-1"
            style={{ height: "40px" }}
          >
            <span>{t("accountOwner.action")}</span>
          </div>
        );
      },
      formatter: (cellContent, row) => {
        const isOtherOwner = isOtherOwnerCredential(row);
        return (
          <div
            className="actions-status-box"
            onMouseDown={preventRowNavigation}
            onClick={preventRowNavigation}
          >
            <UncontrolledDropdown
              tag="div"
              className="interactive-element d-inline-block"
            >
              <DropdownToggle
                caret={false}
                tag="div"
                className="cursor-pointer"
                onMouseDown={preventRowNavigation}
                onClick={preventRowNavigation}
              >
                <div className={`ellipsis-icon`}>
                  <img src={ThreeDots} alt="ThreeDots" />
                </div>
              </DropdownToggle>
              <DropdownMenu
                left
                container={openRef}
                onMouseDown={preventRowNavigation}
              >
                <DropdownItem
                  onMouseDown={preventRowNavigation}
                  onClick={(e) => runDropdownAction(e, () => handleView(row))}
                >
                  <Text className={"office-dropdown-item"}>
                    {t("accountOwner.view")}
                  </Text>
                </DropdownItem>
                <OtherOwnerAwareDropdownItem
                  label={t("accountOwner.edit")}
                  tooltip={t(
                    "accountOwner.cannotEditCredentialAddedByOtherOwner",
                  )}
                  tooltipId={`other-owner-edit-${row.id}`}
                  isOtherOwner={isOtherOwner}
                  onMouseDown={preventRowNavigation}
                  onClick={(e) =>
                    runDropdownAction(e, () => onEdit && onEdit(row))
                  }
                />
                <OtherOwnerAwareDropdownItem
                  label={t("accountOwner.delete")}
                  tooltip={t(
                    "accountOwner.cannotDeleteCredentialAddedByOtherOwner",
                  )}
                  tooltipId={`other-owner-delete-${row.id}`}
                  isOtherOwner={isOtherOwner}
                  onMouseDown={preventRowNavigation}
                  onClick={(e) =>
                    runDropdownAction(e, () => onDelete && onDelete(row))
                  }
                />
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        );
      },
    },
  ];
  return (
    <div className="test-table-box ml-3">
      <div
        className="actions-status-box"
        ref={openRef}
        onMouseDown={preventRowNavigation}
        onClick={preventRowNavigation}
      />
      <Table
        keyField="id"
        tableClassName={`change-heading ${styles["credential-clickable-table"]}`}
        data={data}
        columns={columns}
        bordered={false}
        handlePagination={setPageNumber}
        pageNumber={pageNumber}
        totalItems={totalItems}
        pageSize={PAGE_SIZE}
        rowEvents={rowEvents}
      />
    </div>
  );
};
export default withTranslation()(CredentialGlobalTable);
